(function () {
    angular
    .module('card', []);
})();
